export default (state, action) => {
  switch (action.type) {
    case 'GET_AUDIENCE': {
      return {
        ...state,
        audience: action.payload.audience,
      };
    }
    case 'SET_CURR_AUDIENCE': {
      return {
        ...state,
        currAudience: action.payload.currAudience,
      };
    }
    case 'REFRESH_AUDIENCE': {
      return {
        ...state,
        audience: action.payload.audience,
        currAudience: action.payload.currAudience
      };
    }

    default:
      return state;
  }
};
